import Scroll from "./index.vue";

Scroll.install = function (Vue) {
  Vue.component(Scroll.name, Scroll);
};

export default Scroll;